import { defineStore } from 'pinia';

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    loaded: false,
    loading: false,
    customers: [] as Customer[],
  }),
  actions: {
    async load() {
      if (!this.loaded && !this.loading) {
        await this.reload();
      }
    },
    async reload() {
      const { data: auth } = useAuth();
      this.loading = true;
      const { data } = await useApi().get<Customer[]>(`/organizations/${auth.value!.organization.id}/customers`);
      this.customers = data.value;
      this.loaded = true;
      this.loading = false;
    },
    async updateCustomer(customer: Customer) {
      const response = await useApi().put<Customer>(`/api/customers/${customer.id}`, customer);

      if (!response.data) {
        throw new Error('API did not return updated customer data');
      }
      const updatedCustomer = response.data;
      this.customers = this.customers.map((c: Customer) => (c.id === customer.id ? updatedCustomer : c));

      return updatedCustomer;
    },
    async createCustomer(customer: Customer) {
      const { data: auth } = useAuth();
      const response = await useApi().post<Customer>(`/api/organizations/${auth.value!.organization.id}/customers`, { ...customer });
      if (!response.data) {
        throw new Error('API did not return updated customer data');
      }
      const newCustomer = response.data;
      this.customers.push(newCustomer);

      return newCustomer;
    },
  },
});
